export default __webpack_public_path__ + "static/media/breakfast-leader-milestone-tracker-header.d50ddb1c.png";